import actions from './actions';
import { createReducer } from '../../../../../../../helpers/reducer';

// ------------------------------
// Initial State
// ------------------------------
const initState = {
  invoiceJobs: null,
  loading: false,
  total: 0,
  filteredTotal: 0,
};

// ------------------------------
// Action Handlers
// ------------------------------
function onLoad(state) {
  return {
    ...state,
    loading: true,
    isEdit: false,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal } = payload;
  const invoiceJobs = data;

  return {
    ...state,
    invoiceJobs,
    total,
    filteredTotal,
    loading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

// ------------------------------
// Local util functions
// ------------------------------

// ------------------------------
// Exported reducer function.
// ------------------------------
export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
